module.exports = __webpack_public_path__ + "assets/smd.065d5add.svg";